import { makeAutoObservable } from 'mobx';
import { clearPersistedStore, makePersistable } from 'mobx-persist-store';

class ServiceAdministratorProductLineFormStore {
  params = JSON.stringify({});

  constructor(rootStore) {
    this.rootStore = rootStore;

    makeAutoObservable(this);

    makePersistable(this, {
      name: 'ServiceAdministratorProductLineFormStore',
      properties: ['params'],
    });
  }

  set(newParams) {
    this.params = JSON.stringify(newParams);
  }

  get() {
    return JSON.parse(this.params);
  }

  async clearStore() {
    await clearPersistedStore(this);
  }
}

export default ServiceAdministratorProductLineFormStore;
